(() => {
  const init = () => {
    document.querySelectorAll('[data-product-root]').forEach(root => {
      const nav = root.querySelector('[data-unity-gallery-progress]');
      const gallery = root.querySelector('.product-media-container');
      const scroller = gallery?.querySelector('.splide--product');
      if (!nav || !gallery || !scroller || nav.dataset.ready) return;
      nav.dataset.ready = 'true';
      let slides = [];
      let signature = '';
      let pending = false;
      const update = () => {
        pending = false;
        if (!matchMedia('(min-width: 1024px)').matches) return;
        const visible = Array.from(gallery.querySelectorAll('.splide__slide')).filter(el => el.id && el.getBoundingClientRect().height > 0 && getComputedStyle(el).display !== 'none');
        const nextSignature = visible.map(el => el.id).join('|');
        if (nextSignature !== signature) {
          signature = nextSignature;
          slides = visible;
          const items = document.createElement('div');
          items.className = 'unity-gallery-progress__items';
          slides.forEach((slide, index) => {
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'unity-gallery-progress__dot';
            button.setAttribute('aria-label', (index + 1) + ' / ' + slides.length);
            button.setAttribute('aria-controls', slide.id);
            button.addEventListener('click', () => {
              const top = slide.getBoundingClientRect().top - scroller.getBoundingClientRect().top + scroller.scrollTop;
              scroller.scrollTo({top, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
            });
            items.append(button);
          });
          nav.replaceChildren(items);
          nav.hidden = slides.length < 2;
        }
        const viewport = scroller.getBoundingClientRect();
        const center = viewport.top + viewport.height / 2;
        let active = 0;
        let distance = Infinity;
        slides.forEach((slide, index) => {
          const rect = slide.getBoundingClientRect();
          const d = center < rect.top ? rect.top - center : center > rect.bottom ? center - rect.bottom : 0;
          if (d < distance) { active = index; distance = d; }
        });
        nav.querySelectorAll('button').forEach((button, index) => {
          if (index === active) button.setAttribute('aria-current', 'true');
          else button.removeAttribute('aria-current');
        });
      };
      const schedule = () => { if (!pending) { pending = true; requestAnimationFrame(update); } };
      addEventListener('scroll', schedule, {passive: true});
      scroller.addEventListener('scroll', schedule, {passive: true});
      addEventListener('resize', schedule, {passive: true});
      gallery.addEventListener('load', schedule, true);
      new MutationObserver(schedule).observe(gallery.querySelector('.splide__list'), {subtree: true, attributes: true, attributeFilter: ['class', 'style']});
      update();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
